document.addEventListener('DOMContentLoaded', function () {
    // 1. Category Navigation (Scroll to Section)
    const categoryLinks = document.querySelectorAll('.shop-category-link');
    const sections = document.querySelectorAll('.shop-type-section');

    categoryLinks.forEach((link) => {
        link.addEventListener('click', () => {
            const targetId = link.dataset.target;
            
            if (targetId === 'all') {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            } else {
                const targetSection = document.getElementById(targetId);
                if (targetSection) {
                    const offset = 100; // Account for sticky nav
                    const bodyRect = document.body.getBoundingClientRect().top;
                    const elementRect = targetSection.getBoundingClientRect().top;
                    const elementPosition = elementRect - bodyRect;
                    const offsetPosition = elementPosition - offset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            }

            // Update active state
            categoryLinks.forEach(l => l.classList.remove('is-active'));
            link.classList.add('is-active');
        });
    });

    // 2. Variant Selection
    document.addEventListener('click', function (event) {
        const sizeButton = event.target.closest('.iou-size-button');
        if (!sizeButton || sizeButton.classList.contains('is-unavailable')) return;

        const card = sizeButton.closest('[data-product-card]');
        const variantInput = card.querySelector('[data-variant-input]');

        card.querySelectorAll('.iou-size-button').forEach((button) => {
            button.classList.remove('is-selected');
        });

        sizeButton.classList.add('is-selected');
        variantInput.value = sizeButton.dataset.variantId;
        
        // Reset CTA button text
        const ctaButton = card.querySelector('.iou-product-card__cta[type="submit"]');
        if (ctaButton && ctaButton.dataset.originalText) {
            ctaButton.textContent = ctaButton.dataset.originalText;
        }
    });

    // 2.5 Add to Cart Validation
    document.addEventListener('submit', function (event) {
        const form = event.target;
        if (form.classList.contains('iou-product-form')) {
            const variantInput = form.querySelector('[data-variant-input]');
            if (variantInput && !variantInput.value) {
                event.preventDefault();
                const ctaButton = form.querySelector('.iou-product-card__cta');
                if (ctaButton) {
                    ctaButton.textContent = window.theme?.selectSizeText || 'Select a size';
                }
            }
        }
    });

    // 3. Right-Side Image Slideshow & Hover Logic
    const imageWrappers = document.querySelectorAll('.shop-featured-image-wrapper');
    let slideshowInterval;
    
    function startSlideshow() {
        if (imageWrappers.length > 1) {
            let currentIndex = Array.from(imageWrappers).findIndex(w => w.classList.contains('is-active'));
            if (currentIndex === -1) currentIndex = 0;
            if (slideshowInterval) clearInterval(slideshowInterval);
            slideshowInterval = setInterval(() => {
                imageWrappers[currentIndex].classList.remove('is-active');
                currentIndex = (currentIndex + 1) % imageWrappers.length;
                imageWrappers[currentIndex].classList.add('is-active');
            }, 4000);
        }
    }
    startSlideshow();

    const productCards = document.querySelectorAll('.iou-product-card[data-hover-image]');
    let originalImageSrc = null;
    let originalImageSrcset = null;

    productCards.forEach(card => {
        card.addEventListener('mouseenter', () => {
            const hoverImageUrl = card.dataset.hoverImage;
            const activeWrapper = document.querySelector('.shop-featured-image-wrapper.is-active');
            if (activeWrapper && hoverImageUrl) {
                const img = activeWrapper.querySelector('img');
                if (img) {
                    if (!originalImageSrc) {
                        originalImageSrc = img.src;
                        originalImageSrcset = img.srcset;
                    }
                    img.src = hoverImageUrl;
                    img.srcset = '';
                    if (slideshowInterval) clearInterval(slideshowInterval);
                }
            }
        });
        card.addEventListener('mouseleave', () => {
            const activeWrapper = document.querySelector('.shop-featured-image-wrapper.is-active');
            if (activeWrapper && originalImageSrc) {
                const img = activeWrapper.querySelector('img');
                if (img) {
                    img.src = originalImageSrc;
                    if (originalImageSrcset) img.srcset = originalImageSrcset;
                    originalImageSrc = null;
                    originalImageSrcset = null;
                    startSlideshow();
                }
            }
        });
    });

    // 4. Update active category on scroll
    window.addEventListener('scroll', () => {
        let currentSection = '';
        const scrollPosition = window.scrollY + 150;

        sections.forEach((section) => {
            const sectionTop = section.offsetTop;
            if (scrollPosition >= sectionTop) {
                currentSection = section.id;
            }
        });

        if (currentSection) {
            categoryLinks.forEach((link) => {
                link.classList.toggle('is-active', link.dataset.target === currentSection);
            });
        } else if (window.scrollY < 200) {
            categoryLinks.forEach((link) => {
                link.classList.toggle('is-active', link.dataset.target === 'all');
            });
        }
    });
});
